module.exports = __webpack_public_path__ + "img/mw.d8211604.svg";